import { Stack, Typography } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import ExecutorSelect from "src/sites/file/ExecutorSelect"
import { SimpleExecutorRecord } from "src/services/api/document"
import { Community } from "@models/user"
import { useResponsive } from "src/utils/useResponsive"
import { useExecutorSelection } from "./useExecutorSelection"

interface ExecutorsSelectionProps {
  enhancer: SimpleExecutorRecord
  setEnhancer: (enhancer: SimpleExecutorRecord) => void
  trustminer?: SimpleExecutorRecord
  setTrustminer: (trustminer: SimpleExecutorRecord) => void
  withTrusminer?: boolean
  communities: Community[]
}

export const ExecutorsSelection = ({
  enhancer,
  setEnhancer,
  trustminer,
  setTrustminer,
  withTrusminer,
  communities
}: ExecutorsSelectionProps) => {
  const { t } = useTranslation("common")
  const { isMobile } = useResponsive()
  const { executorList, handleEnhancerChange, handleTrustminerChange } = useExecutorSelection({
    communities,
    enhancer,
    trustminer,
    onEnhancerChange: setEnhancer,
    onTrustminerChange: setTrustminer,
    withTrusminer
  })

  return !!executorList?.length ? (
    <Stack spacing={3} sx={{ p: { xs: 0, md: 4 }, pt: {xs: 1, md: 0} }}>
      {!isMobile && <Typography variant="h5">{t("document.inhouseTeam")}</Typography>}
      <ExecutorSelect
        label={t("firstStage")}
        selected={enhancer || executorList.filter((e: SimpleExecutorRecord) => e.id !== trustminer?.id)[0]}
        onChanged={handleEnhancerChange}
        executorList={executorList}
      />

      {withTrusminer && executorList.length > 0 && (
        <ExecutorSelect
          label={t("secondStage")}
          selected={trustminer || executorList.filter((e: SimpleExecutorRecord) => e.id !== enhancer?.id)[0]}
          onChanged={handleTrustminerChange}
          executorList={executorList}
        />
      )}
    </Stack>
  ) : (
    <></>
  )
}
